<div class="wrapper">
  <div [innerHtml]="'app.gdpr.text' | i18n" class="doc"></div>
</div>
